export const timezones: TimeZone[] = [
  {
    label: "Niue",
    value: "Pacific/Niue",
  },
  {
    label: "Pago Pago",
    value: "Pacific/Pago_Pago",
  },
  {
    label: "Hawaii Time",
    value: "Pacific/Honolulu",
  },
  {
    label: "Rarotonga",
    value: "Pacific/Rarotonga",
  },
  {
    label: "Tahiti",
    value: "Pacific/Tahiti",
  },
  {
    label: "Marquesas",
    value: "Pacific/Marquesas",
  },
  {
    label: "Gambier",
    value: "Pacific/Gambier",
  },
  {
    label: "Alaska Time",
    value: "America/Anchorage",
  },
  {
    label: "Pitcairn",
    value: "Pacific/Pitcairn",
  },
  {
    label: "Dawson",
    value: "America/Dawson",
  },
  {
    label: "Mountain Time - Arizona",
    value: "America/Phoenix",
  },
  {
    label: "Mountain Time - Dawson Creek",
    value: "America/Dawson_Creek",
  },
  {
    label: "Mountain Time - Hermosillo",
    value: "America/Hermosillo",
  },
  {
    label: "Pacific Time",
    value: "America/Los_Angeles",
  },
  {
    label: "Pacific Time - Tijuana",
    value: "America/Tijuana",
  },
  {
    label: "Pacific Time - Vancouver",
    value: "America/Vancouver",
  },
  {
    label: "Pacific Time - Whitehorse",
    value: "America/Whitehorse",
  },
  {
    label: "Belize",
    value: "America/Belize",
  },
  {
    label: "Boise",
    value: "America/Boise",
  },
  {
    label: "Central Time - Regina",
    value: "America/Regina",
  },
  {
    label: "Central Time - Tegucigalpa",
    value: "America/Tegucigalpa",
  },
  {
    label: "Costa Rica",
    value: "America/Costa_Rica",
  },
  {
    label: "Easter Island",
    value: "Pacific/Easter",
  },
  {
    label: "El Salvador",
    value: "America/El_Salvador",
  },
  {
    label: "Galapagos",
    value: "Pacific/Galapagos",
  },
  {
    label: "Guatemala",
    value: "America/Guatemala",
  },
  {
    label: "Managua",
    value: "America/Managua",
  },
  {
    label: "Mountain Time",
    value: "America/Denver",
  },
  {
    label: "Mountain Time - Chihuahua, Mazatlan",
    value: "America/Mazatlan",
  },
  {
    label: "Mountain Time - Edmonton",
    value: "America/Edmonton",
  },
  {
    label: "Mountain Time - Yellowknife",
    value: "America/Yellowknife",
  },
  {
    label: "America Cancun",
    value: "America/Cancun",
  },
  {
    label: "Bogota",
    value: "America/Bogota",
  },
  {
    label: "Central Time",
    value: "America/Chicago",
  },
  {
    label: "Central Time - Mexico City",
    value: "America/Mexico_City",
  },
  {
    label: "Central Time - Winnipeg",
    value: "America/Winnipeg",
  },
  {
    label: "Guayaquil",
    value: "America/Guayaquil",
  },
  {
    label: "Jamaica",
    value: "America/Jamaica",
  },
  {
    label: "Lima",
    value: "America/Lima",
  },
  {
    label: "Panama",
    value: "America/Panama",
  },
  {
    label: "Rio Branco",
    value: "America/Rio_Branco",
  },
  {
    label: "Asuncion",
    value: "America/Asuncion",
  },
  {
    label: "Barbados",
    value: "America/Barbados",
  },
  {
    label: "Boa Vista",
    value: "America/Boa_Vista",
  },
  {
    label: "Campo Grande",
    value: "America/Campo_Grande",
  },
  {
    label: "Caracas",
    value: "America/Caracas",
  },
  {
    label: "Cuiaba",
    value: "America/Cuiaba",
  },
  {
    label: "Curacao",
    value: "America/Curacao",
  },
  {
    label: "Detroit",
    value: "America/Detroit",
  },
  {
    label: "Eastern Time",
    value: "America/New_York",
  },
  {
    label: "Eastern Time - Iqaluit",
    value: "America/Iqaluit",
  },
  {
    label: "Eastern Time - Toronto",
    value: "America/Toronto",
  },
  {
    label: "Grand Turk",
    value: "America/Grand_Turk",
  },
  {
    label: "Guyana",
    value: "America/Guyana",
  },
  {
    label: "Havana",
    value: "America/Havana",
  },
  {
    label: "La Paz",
    value: "America/La_Paz",
  },
  {
    label: "Manaus",
    value: "America/Manaus",
  },
  {
    label: "Martinique",
    value: "America/Martinique",
  },
  {
    label: "Nassau",
    value: "America/Nassau",
  },
  {
    label: "Port of Spain",
    value: "America/Port_of_Spain",
  },
  {
    label: "Port-au-Prince",
    value: "America/Port-au-Prince",
  },
  {
    label: "Porto Velho",
    value: "America/Porto_Velho",
  },
  {
    label: "Puerto Rico",
    value: "America/Puerto_Rico",
  },
  {
    label: "Santiago",
    value: "America/Santiago",
  },
  {
    label: "Santo Domingo",
    value: "America/Santo_Domingo",
  },
  {
    label: "Araguaina",
    value: "America/Araguaina",
  },
  {
    label: "Atlantic Time - Halifax",
    value: "America/Halifax",
  },
  {
    label: "Belem",
    value: "America/Belem",
  },
  {
    label: "Bermuda",
    value: "Atlantic/Bermuda",
  },
  {
    label: "Buenos Aires",
    value: "America/Argentina/Buenos_Aires",
  },
  {
    label: "Cayenne",
    value: "America/Cayenne",
  },
  {
    label: "Cordoba",
    value: "America/Argentina/Cordoba",
  },
  {
    label: "Fortaleza",
    value: "America/Fortaleza",
  },
  {
    label: "Maceio",
    value: "America/Maceio",
  },
  {
    label: "Montevideo",
    value: "America/Montevideo",
  },
  {
    label: "Palmer",
    value: "Antarctica/Palmer",
  },
  {
    label: "Paramaribo",
    value: "America/Paramaribo",
  },
  {
    label: "Punta Arenas",
    value: "America/Punta_Arenas",
  },
  {
    label: "Recife",
    value: "America/Recife",
  },
  {
    label: "Rothera",
    value: "Antarctica/Rothera",
  },
  {
    label: "Salvador",
    value: "America/Bahia",
  },
  {
    label: "Sao Paulo",
    value: "America/Sao_Paulo",
  },
  {
    label: "Stanley",
    value: "Atlantic/Stanley",
  },
  {
    label: "Thule",
    value: "America/Thule",
  },
  {
    label: "Newfoundland Time - St. Johns",
    value: "America/St_Johns",
  },
  {
    label: "Godthab",
    value: "America/Godthab",
  },
  {
    label: "Miquelon",
    value: "America/Miquelon",
  },
  {
    label: "Noronha",
    value: "America/Noronha",
  },
  {
    label: "South Georgia",
    value: "Atlantic/South_Georgia",
  },
  {
    label: "Cape Verde",
    value: "Atlantic/Cape_Verde",
  },
  {
    label: "Abidjan",
    value: "Africa/Abidjan",
  },
  {
    label: "Accra",
    value: "Africa/Accra",
  },
  {
    label: "Azores",
    value: "Atlantic/Azores",
  },
  {
    label: "Bissau",
    value: "Africa/Bissau",
  },
  {
    label: "Casablanca",
    value: "Africa/Casablanca",
  },
  {
    label: "Danmarkshavn",
    value: "America/Danmarkshavn",
  },
  {
    label: "El Aaiun",
    value: "Africa/El_Aaiun",
  },
  {
    label: "GMT",
    value: "Etc/GMT",
  },
  {
    label: "Monrovia",
    value: "Africa/Monrovia",
  },
  {
    label: "Reykjavik",
    value: "Atlantic/Reykjavik",
  },
  {
    label: "Scoresbysund",
    value: "America/Scoresbysund",
  },
  {
    label: "UTC",
    value: "UTC",
  },
  {
    label: "Algiers",
    value: "Africa/Algiers",
  },
  {
    label: "Canary Islands",
    value: "Atlantic/Canary",
  },
  {
    label: "Dublin",
    value: "Europe/Dublin",
  },
  {
    label: "Faeroe",
    value: "Atlantic/Faroe",
  },
  {
    label: "Lagos",
    value: "Africa/Lagos",
  },
  {
    label: "Lisbon",
    value: "Europe/Lisbon",
  },
  {
    label: "London",
    value: "Europe/London",
  },
  {
    label: "Ndjamena",
    value: "Africa/Ndjamena",
  },
  {
    label: "Sao Tome",
    value: "Africa/Sao_Tome",
  },
  {
    label: "Tunis",
    value: "Africa/Tunis",
  },
  {
    label: "Amsterdam",
    value: "Europe/Amsterdam",
  },
  {
    label: "Andorra",
    value: "Europe/Andorra",
  },
  {
    label: "Berlin",
    value: "Europe/Berlin",
  },
  {
    label: "Brussels",
    value: "Europe/Brussels",
  },
  {
    label: "Budapest",
    value: "Europe/Budapest",
  },
  {
    label: "Cairo",
    value: "Africa/Cairo",
  },
  {
    label: "Central European Time - Belgrade",
    value: "Europe/Belgrade",
  },
  {
    label: "Central European Time - Prague",
    value: "Europe/Prague",
  },
  {
    label: "Ceuta",
    value: "Africa/Ceuta",
  },
  {
    label: "Copenhagen",
    value: "Europe/Copenhagen",
  },
  {
    label: "Gibraltar",
    value: "Europe/Gibraltar",
  },
  {
    label: "Johannesburg",
    value: "Africa/Johannesburg",
  },
  {
    label: "Khartoum",
    value: "Africa/Khartoum",
  },
  {
    label: "Luxembourg",
    value: "Europe/Luxembourg",
  },
  {
    label: "Madrid",
    value: "Europe/Madrid",
  },
  {
    label: "Malta",
    value: "Europe/Malta",
  },
  {
    label: "Maputo",
    value: "Africa/Maputo",
  },
  {
    label: "Monaco",
    value: "Europe/Monaco",
  },
  {
    label: "Moscow-01 - Kaliningrad",
    value: "Europe/Kaliningrad",
  },
  {
    label: "Oslo",
    value: "Europe/Oslo",
  },
  {
    label: "Paris",
    value: "Europe/Paris",
  },
  {
    label: "Rome",
    value: "Europe/Rome",
  },
  {
    label: "Stockholm",
    value: "Europe/Stockholm",
  },
  {
    label: "Tirane",
    value: "Europe/Tirane",
  },
  {
    label: "Tripoli",
    value: "Africa/Tripoli",
  },
  {
    label: "Vienna",
    value: "Europe/Vienna",
  },
  {
    label: "Warsaw",
    value: "Europe/Warsaw",
  },
  {
    label: "Windhoek",
    value: "Africa/Windhoek",
  },
  {
    label: "Zurich",
    value: "Europe/Zurich",
  },
  {
    label: "Amman",
    value: "Asia/Amman",
  },
  {
    label: "Athens",
    value: "Europe/Athens",
  },
  {
    label: "Baghdad",
    value: "Asia/Baghdad",
  },
  {
    label: "Beirut",
    value: "Asia/Beirut",
  },
  {
    label: "Bucharest",
    value: "Europe/Bucharest",
  },
  {
    label: "Chisinau",
    value: "Europe/Chisinau",
  },
  {
    label: "Damascus",
    value: "Asia/Damascus",
  },
  {
    label: "Gaza",
    value: "Asia/Gaza",
  },
  {
    label: "Helsinki",
    value: "Europe/Helsinki",
  },
  {
    label: "Istanbul",
    value: "Europe/Istanbul",
  },
  {
    label: "Jerusalem",
    value: "Asia/Jerusalem",
  },
  {
    label: "Kiev",
    value: "Europe/Kiev",
  },
  {
    label: "Minsk",
    value: "Europe/Minsk",
  },
  {
    label: "Moscow+00 - Moscow",
    value: "Europe/Moscow",
  },
  {
    label: "Nairobi",
    value: "Africa/Nairobi",
  },
  {
    label: "Nicosia",
    value: "Asia/Nicosia",
  },
  {
    label: "Qatar",
    value: "Asia/Qatar",
  },
  {
    label: "Riga",
    value: "Europe/Riga",
  },
  {
    label: "Riyadh",
    value: "Asia/Riyadh",
  },
  {
    label: "Sofia",
    value: "Europe/Sofia",
  },
  {
    label: "Syowa",
    value: "Antarctica/Syowa",
  },
  {
    label: "Tallinn",
    value: "Europe/Tallinn",
  },
  {
    label: "Vilnius",
    value: "Europe/Vilnius",
  },
  {
    label: "Baku",
    value: "Asia/Baku",
  },
  {
    label: "Dubai",
    value: "Asia/Dubai",
  },
  {
    label: "Mahe",
    value: "Indian/Mahe",
  },
  {
    label: "Mauritius",
    value: "Indian/Mauritius",
  },
  {
    label: "Moscow+01 - Samara",
    value: "Europe/Samara",
  },
  {
    label: "Reunion",
    value: "Indian/Reunion",
  },
  {
    label: "Tbilisi",
    value: "Asia/Tbilisi",
  },
  {
    label: "Yerevan",
    value: "Asia/Yerevan",
  },
  {
    label: "Kabul",
    value: "Asia/Kabul",
  },
  {
    label: "Tehran",
    value: "Asia/Tehran",
  },
  {
    label: "Aqtau",
    value: "Asia/Aqtau",
  },
  {
    label: "Aqtobe",
    value: "Asia/Aqtobe",
  },
  {
    label: "Ashgabat",
    value: "Asia/Ashgabat",
  },
  {
    label: "Dushanbe",
    value: "Asia/Dushanbe",
  },
  {
    label: "Karachi",
    value: "Asia/Karachi",
  },
  {
    label: "Kerguelen",
    value: "Indian/Kerguelen",
  },
  {
    label: "Maldives",
    value: "Indian/Maldives",
  },
  {
    label: "Mawson",
    value: "Antarctica/Mawson",
  },
  {
    label: "Moscow+02 - Yekaterinburg",
    value: "Asia/Yekaterinburg",
  },
  {
    label: "Tashkent",
    value: "Asia/Tashkent",
  },
  {
    label: "Colombo",
    value: "Asia/Colombo",
  },
  {
    label: "India Standard Time",
    value: "Asia/Calcutta",
  },
  {
    label: "Katmandu",
    value: "Asia/Katmandu",
  },
  {
    label: "Almaty",
    value: "Asia/Almaty",
  },
  {
    label: "Bishkek",
    value: "Asia/Bishkek",
  },
  {
    label: "Chagos",
    value: "Indian/Chagos",
  },
  {
    label: "Dhaka",
    value: "Asia/Dhaka",
  },
  {
    label: "Moscow+03 - Omsk",
    value: "Asia/Omsk",
  },
  {
    label: "Thimphu",
    value: "Asia/Thimphu",
  },
  {
    label: "Vostok",
    value: "Antarctica/Vostok",
  },
  {
    label: "Cocos",
    value: "Indian/Cocos",
  },
  {
    label: "Rangoon",
    value: "Asia/Yangon",
  },
  {
    label: "Bangkok",
    value: "Asia/Bangkok",
  },
  {
    label: "Christmas",
    value: "Indian/Christmas",
  },
  {
    label: "Davis",
    value: "Antarctica/Davis",
  },
  {
    label: "Hanoi",
    value: "Asia/Saigon",
  },
  {
    label: "Hovd",
    value: "Asia/Hovd",
  },
  {
    label: "Jakarta",
    value: "Asia/Jakarta",
  },
  {
    label: "Moscow+04 - Krasnoyarsk",
    value: "Asia/Krasnoyarsk",
  },
  {
    label: "Brunei",
    value: "Asia/Brunei",
  },
  {
    label: "Casey",
    value: "Antarctica/Casey",
  },
  {
    label: "China Time - Beijing",
    value: "Asia/Shanghai",
  },
  {
    label: "Choibalsan",
    value: "Asia/Choibalsan",
  },
  {
    label: "Hong Kong",
    value: "Asia/Hong_Kong",
  },
  {
    label: "Kuala Lumpur",
    value: "Asia/Kuala_Lumpur",
  },
  {
    label: "Macau",
    value: "Asia/Macau",
  },
  {
    label: "Makassar",
    value: "Asia/Makassar",
  },
  {
    label: "Manila",
    value: "Asia/Manila",
  },
  {
    label: "Moscow+05 - Irkutsk",
    value: "Asia/Irkutsk",
  },
  {
    label: "Singapore",
    value: "Asia/Singapore",
  },
  {
    label: "Taipei",
    value: "Asia/Taipei",
  },
  {
    label: "Ulaanbaatar",
    value: "Asia/Ulaanbaatar",
  },
  {
    label: "Western Time - Perth",
    value: "Australia/Perth",
  },
  {
    label: "Dili",
    value: "Asia/Dili",
  },
  {
    label: "Jayapura",
    value: "Asia/Jayapura",
  },
  {
    label: "Moscow+06 - Yakutsk",
    value: "Asia/Yakutsk",
  },
  {
    label: "Palau",
    value: "Pacific/Palau",
  },
  {
    label: "Pyongyang",
    value: "Asia/Pyongyang",
  },
  {
    label: "Seoul",
    value: "Asia/Seoul",
  },
  {
    label: "Tokyo",
    value: "Asia/Tokyo",
  },
  {
    label: "Central Time - Adelaide",
    value: "Australia/Adelaide",
  },
  {
    label: "Central Time - Darwin",
    value: "Australia/Darwin",
  },
  {
    label: "Dumont D'Urville",
    value: "Antarctica/DumontDUrville",
  },
  {
    label: "Eastern Time - Brisbane",
    value: "Australia/Brisbane",
  },
  {
    label: "Eastern Time - Hobart",
    value: "Australia/Hobart",
  },
  {
    label: "Eastern Time - Melbourne",
    value: "Australia/Melbourne",
  },
  {
    label: "Eastern Time - Melbourne, Sydney",
    value: "Australia/Sydney",
  },
  {
    label: "Guam",
    value: "Pacific/Guam",
  },
  {
    label: "Moscow+07 - Vladivostok",
    value: "Asia/Vladivostok",
  },
  {
    label: "Port Moresby",
    value: "Pacific/Port_Moresby",
  },
  {
    label: "Truk",
    value: "Pacific/Chuuk",
  },
  {
    label: "Efate",
    value: "Pacific/Efate",
  },
  {
    label: "Guadalcanal",
    value: "Pacific/Guadalcanal",
  },
  {
    label: "Kosrae",
    value: "Pacific/Kosrae",
  },
  {
    label: "Moscow+08 - Magadan",
    value: "Asia/Magadan",
  },
  {
    label: "Norfolk",
    value: "Pacific/Norfolk",
  },
  {
    label: "Noumea",
    value: "Pacific/Noumea",
  },
  {
    label: "Ponape",
    value: "Pacific/Pohnpei",
  },
  {
    label: "Auckland",
    value: "Pacific/Auckland",
  },
  {
    label: "Fiji",
    value: "Pacific/Fiji",
  },
  {
    label: "Funafuti",
    value: "Pacific/Funafuti",
  },
  {
    label: "Kwajalein",
    value: "Pacific/Kwajalein",
  },
  {
    label: "Majuro",
    value: "Pacific/Majuro",
  },
  {
    label: "Moscow+09 - Petropavlovsk-Kamchatskiy",
    value: "Asia/Kamchatka",
  },
  {
    label: "Nauru",
    value: "Pacific/Nauru",
  },
  {
    label: "Tarawa",
    value: "Pacific/Tarawa",
  },
  {
    label: "Wake",
    value: "Pacific/Wake",
  },
  {
    label: "Wallis",
    value: "Pacific/Wallis",
  },
  {
    label: "Apia",
    value: "Pacific/Apia",
  },
  {
    label: "Enderbury",
    value: "Pacific/Enderbury",
  },
  {
    label: "Fakaofo",
    value: "Pacific/Fakaofo",
  },
  {
    label: "Tongatapu",
    value: "Pacific/Tongatapu",
  },
  {
    label: "Kiritimati",
    value: "Pacific/Kiritimati",
  },
];
